interface ApplyRuleErrorResponse {
  field: string;
  message: string;
}

function getKeys(schema: RulesSchema, attrs?: string[]) {
  let keys = Object.keys(schema.attr);
  if (attrs) {
    keys = keys.filter((key) => attrs.includes(key));
  }
  return keys;
}

function applyRulesArray(rules: Array<((v: any) => boolean | string)>, key: string, value: any) {
  const found = rules.map((r: any) => r(value)).find((v: any) => v !== true);
  if (found) {
    return {
      field: key,
      message: found,
    };
  }
  return true;
}

function applySchemaToValues(values: any[], schema: RulesSchema) {
  const found2 = values.map((v: any) => applyRules(v, schema)).find((v: any) => v !== true);
  if (found2) {
    return found2;
  }
  return true;
}

/**
 * Apply a rule schema to an object.
 *
 * @param data The object to be validated
 * @param rulesSchema The rule schema to be followed by the object
 * @param attrs The optional attributes to be checked.
 */
export const applyRules = (
  data: any, rulesSchema: RulesSchema, attrs?: string[],
): ApplyRuleErrorResponse | true => {
  try {
    const keys = getKeys(rulesSchema, attrs);
    for (const key of keys) {
      const value = data[key];
      const rules = rulesSchema.attr[key];
      if ((rules as RuleArraySchema).rules) {
        const result = applyRulesArray((rules as any).rules, key, value);
        if (result === true) {
          if (Array.isArray(value)) {
            const result2 = applySchemaToValues(value, (rules as RuleArraySchema).schema);
            if (result2 !== true) {
              return { ...result2, field: `${key}.${result2.field}`};
            }
          } else {
            const result2 = applyRules(value, (rules as RuleArraySchema).schema);
            if (result2 !== true) {
              return { ...result2, field: `${key}.${result2.field}` };
            }
          }
        } else {
          return result;
        }
      } else if (Array.isArray(value)) {
        const result = applySchemaToValues(value, rules as RulesSchema);
        if (result !== true) {
          return {
            ...result,
            field: `${key}.${result.field}`,
          };
        }
      } else if (!(value instanceof Date) && typeof(value) === 'object') {
        const result = applyRules(value, rules as RulesSchema);
        if (result !== true) {
          return {
            ...result,
            field: `${key}.${result.field}`,
          };
        }
      } else {
        const result = applyRulesArray(rules as any, key, value);
        if (result !== true) {
          return result;
        }
      }
    }
    return true;
  } catch (error) {
    return error.message;
  }
};

interface RuleArraySchema {
  rules: Array<((v: any) => boolean | string)>;
  schema: RulesSchema;
}

export interface RulesSchema {
  attr: {
    [attr: string]:
      Array<((v: any) => boolean | string)> | // array of rules
      ((v: any) => RulesSchema) | // function the returns another rule schema
      RulesSchema | // another rule schema
      RuleArraySchema, // rule array schema
  };
}
